import { createI18n } from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import thLocale from './th'
const messages = {
  en_US: {
    ...enLocale
  },
  zh_CN: {
    ...zhLocale
  },
  th: {
    ...thLocale
  }
}
export function getLanguage() {
  const chooseLanguage = localStorage.getItem('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  /* const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase()
  console.log(language)
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  } */
  return 'CN'
}
const i18n = createI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  legacy: false,
  // set locale messages
  messages
})

export default i18n
